module.exports = __webpack_public_path__ + "img/ch10_02_店外三件套.6b949715.jpg";